<template>
  <div class="page_main">
    <div class="left side_list">
      <div class="general_box item_box">
        <div class="item_title_box">电梯概况</div>
        <div class="general_content">
          <div class="item_box">
            <div class="item_list">
              <img class="icon" src="@/assets/image/d1.png" alt="" />
              <div class="list_desc">
                <div class="label">电梯</div>
                <div class="num">{{ formData.totalElevators }}<span>台</span></div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d2.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网电梯</div>
                <div class="num">{{ formData.iotElevators }}<span>台</span></div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d3.png" alt="" />
              <div class="list_desc">
                <div class="label">在线电梯</div>
                <div class="num">{{ formData.onlineElevators }}<span>台</span></div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d4.png" alt="" />
              <div class="list_desc">
                <div class="label">离线电梯</div>
                <div class="num">{{ formData.offlineElevators }}<span>台</span></div>
              </div>
            </div>
          </div>
          <div class="line" />
          <div class="item_box">
            <div class="item_list">
              <img class="icon" src="@/assets/image/d5.png" alt="" />
              <div class="list_desc">
                <div class="label">使用单位数量</div>
                <div class="num">{{ formData.usageUnit }}</div>
                <!-- <div class="num">30</div> -->
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d6.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网覆盖率</div>
                <div class="num">
                  {{ percentage(formData.iotElevators, formData.totalElevators) }}<span>%</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d7.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网在线率</div>
                <div class="num">
                  {{ percentage(formData.onlineElevators, formData.iotElevators) }}<span>%</span>
                </div>
              </div>
            </div>
            <div class="item_list">
              <img class="icon" src="@/assets/image/d8.png" alt="" />
              <div class="list_desc">
                <div class="label">物联网离线率</div>
                <div class="num">
                  {{
                    percentage(
                      formData.iotElevators - formData.onlineElevators,
                      formData.iotElevators
                    )
                  }}<span>%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="thirtydays_box item_box">
        <div class="item_title_box">电梯梯龄统计板块内容</div>
        <!-- <div class="item_title_box">近30天故障分布统计</div> -->
        <div class="thirtydays_content" id="malfunction">
          <img v-if="!hasAgeData" class="empty_image" src="@/assets/image/nothing.png" alt="暂无数据" />
        </div>
      </div>
      <div class="charts_bottom_box item_box">
        <div class="item_title_box">近30天告警类型统计</div>
        <div class="charts_container" id="warnTypeThirty">
          <img
            v-if="thirtyWarnType.length === 0"
            class="empty_image"
            src="@/assets/image/nothing.png"
            alt="暂无数据"
          />
        </div>
      </div>
    </div>
    <div class="center">
      <div class="map_box">
        <div class="back" v-if="showBack()" @click="backToProvince"></div>
        <div class="map_content" id="map"></div>
      </div>
      <div class="center_bottom">
        <div class="charts_bottom_box item_box">
          <div class="item_title_box">近7天电梯告警率趋势</div>
          <div class="charts_container" id="warnTypeSeven">
            <img
              v-if="sevenWarn.length === 0"
              class="empty_image"
              src="@/assets/image/nothing.png"
              alt="暂无数据"
            />
          </div>
        </div>
        <div class="charts_bottom_box item_box">
          <div class="item_title_box">近30天困人次数趋势</div>
          <div class="charts_container" id="warnTime">
            <img
              v-if="thirtyWarnTime.length === 0"
              class="empty_image"
              src="@/assets/image/nothing.png"
              alt="暂无数据"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="right side_list">
      <div class="today_warn_box item_box">
        <div class="item_title_box">今日告警</div>
        <div class="today_warn_content">
          <div class="today_charts" id="warnToday"></div>
          <div class="today_legend">
            <div class="legend_list">
              <img class="icon" src="@/assets/image/l1.png" alt="" />
              <img class="line" src="@/assets/image/line1.png" alt="" />
              <div class="value_box">
                <div class="status">
                  <img class="arrow" src="@/assets/image/ar1.png" alt="" />
                  已解除
                </div>
                <div class="value">{{ formData.daysRelieveNo }}</div>
              </div>
            </div>
            <div class="legend_list">
              <img class="icon" src="@/assets/image/l2.png" alt="" />
              <img class="line" src="@/assets/image/line2.png" alt="" />
              <div class="value_box">
                <div class="status warn">
                  <img class="arrow" src="@/assets/image/ar2.png" alt="" />
                  维修中
                </div>
                <div class="value">{{ formData.serviceNo }}</div>
              </div>
            </div>
            <div class="legend_list">
              <img class="icon" src="@/assets/image/l3.png" alt="" />
              <img class="line" src="@/assets/image/line3.png" alt="" />
              <div class="value_box">
                <div class="status danger">
                  <img class="arrow" src="@/assets/image/ar3.png" alt="" />
                  未解除
                </div>
                <div class="value">{{ formData.dayNotNo }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="real_time item_box">
        <div class="item_title_box">近30天告警维保单位TOP10</div>
        <div class="real_content">
          <div class="real_box" :class="{ empty_state: realWarnList.length === 0 }">
            <div class="swiper-wrapper">
              <!-- <div
              class="swiper-wrapper"
              v-for="(item, index) in 5"
              :key="index"
              @click="lookMask"
            > -->
              <div
                class="real_list swiper-slide"
                v-for="(item, index) in realWarnList"
                :key="index"
              >
                <div class="item_list">
                  <div class="label_box">
                    <!-- <div class="tag">未解除</div> -->
                    <div class="tag2">{{ item.faultType }}</div>
                    <div class="text">超期未保养数量 {{ item.count }}</div>
                    <div class="warn_bottom">
                      <!-- <div class="text">{{ item.aa }}</div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              v-if="realWarnList.length == 0"
              class="nothing"
              src="@/assets/image/nothing.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="charts_bottom_box item_box">
        <div class="item_title_box">近30天告警使用单位TOP10</div>
        <div class="charts_container use_box">
          <div class="swiper-wrapper">
            <div
              class="unit_list swiper-slide"
              v-for="(item, index) in thirtyWarnUnit"
              :key="index"
            >
              <div class="sort_item">
                <div class="sort_info">
                  <img v-if="index == 0" class="icon" src="@/assets/image/n1.png" />
                  <img v-if="index == 1" class="icon" src="@/assets/image/n2.png" />
                  <img v-if="index == 2" class="icon" src="@/assets/image/n3.png" />
                  <div class="sort">NO.{{ index + 1 }} {{ item.faultType }}</div>
                  <div :class="index == 0 ? 'value first' : 'value'">
                    {{ item.count }}
                  </div>
                </div>
                <div class="process_box">
                  <div
                    :class="index == 0 ? 'process active' : 'process'"
                    :style="
                      'width:' + (unitTotal ? Number(item.count) / unitTotal : 0) + '%;'
                    "
                  >
                    <div class="process_line"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            v-if="thirtyWarnUnit.length === 0"
            class="empty_image"
            src="@/assets/image/nothing.png"
            alt="暂无数据"
          />
        </div>
      </div>
    </div>
    <TheMask ref="mask" />
  </div>
</template>

<script>
import { getDataCenter, getMapData, getBoardData } from "@/api/user";
import { areaIdMap, areaNameMap, mapDataToEcharts, mapDataToPoints } from "@/utils";

import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";
import TheMask from "../theMask/index.vue";

import hubeiGeoJson from "@/utils/map.json"; // 湖北省geojson
// 市区geojson示例引入写法（实际建议动态import或按需加载）
import shiyan from "@/utils/cities/shiyan.json";
import shennongjia from "@/utils/cities/shennongjia.json";
import enshi from "@/utils/cities/enshi.json";
import xiangyang from "@/utils/cities/xiangyang.json";
import yichang from "@/utils/cities/yichang.json";
import suizhou from "@/utils/cities/suizhou.json";
import jingmen from "@/utils/cities/jingmen.json";
import jingzhou from "@/utils/cities/jingzhou.json";
import xiaogan from "@/utils/cities/xiaogan.json";
import tianmen from "@/utils/cities/tianmen.json";
import qianjiang from "@/utils/cities/qianjiang.json";
import xiantao from "@/utils/cities/xiantao.json";
import wuhan from "@/utils/cities/wuhan.json";
import huanggang from "@/utils/cities/huanggang.json";
import ezhou from "@/utils/cities/ezhou.json";
import huangshi from "@/utils/cities/huangshi.json";
import xianning from "@/utils/cities/xianning.json";
export default {
  name: "IndexHome",
  components: {
    TheMask,
  },
  data() {
    return {
      formData: {
        totalElevators: 0,
        iotElevators: 0,
        onlineElevators: 0,
        offlineElevators: 0,
        usageUnit: 0,
        daysRelieveNo: 0,
        serviceNo: 0,
        dayNotNo: 0,
      },
      thirtyFault: [],
      thirtyWarnType: [],
      sevenWarn: [],
      thirtyWarnTime: [],
      thirtyWarnUnit: [],
      boardForm: {
        threeYearsNumber: 0,
        twoYearsNumber: 0,
        sixYearsNumber: 0,
        nineYearsNumber: 0,
        twelveYearsNumber: 0,
        fifteenYearsNumber: 0,
      },
      unitTotal: 0,
      currentLevel: "province", // 省级或市级
      currentMapName: "hubei", // 当前注册的地图名称
      // url: "wss://lift.yqdiot.cn/websocket/eventMessage",
      // url: "ws://192.168.0.103:8380/websocket/eventMessage",
      // webSocket: null,
      first: true,
      realWarnList: [],
      code: "",
      parentCode: "",
      codeText: "",
      resizeHandler: null,
      useUnitSwiper: null,
      realWarnSwiper: null,
      codeList: [
        "420100",
        "420200",
        "420300",
        "420500",
        "420600",
        "420700",
        "420800",
        "420900",
        "421000",
        "421100",
        "421200",
        "421300",
        "422800",
        "429004",
        "429005",
        "429006",
        "429021",
      ],
    };
  },
  computed: {
    hasAgeData() {
      return [
        this.boardForm.threeYearsNumber,
        this.boardForm.twoYearsNumber,
        this.boardForm.sixYearsNumber,
        this.boardForm.nineYearsNumber,
        this.boardForm.twelveYearsNumber,
        this.boardForm.fifteenYearsNumber,
      ].some((value) => Number(value) > 0);
    },
  },
  mounted() {
    const query = window.location.hash.split("?")[1];
    // 解析 URL 参数
    const urlParams = new URLSearchParams(query);
    const token = urlParams.get("token");
    const code = urlParams.get("code");
    if (code) {
      localStorage.setItem("code", code); // 或存到 Vuex
    }
    if (token) {
      localStorage.setItem("token", token); // 或存到 Vuex
    }

    // 响应式：窗口变化时重绘 echarts
    this.resizeHandler = () => this.resizeCharts();
    window.addEventListener("resize", this.resizeHandler);
    // 响应式布局下 echarts init 时容器可能尚未 layout 完毕，
    // 延迟 300ms 强制首次 resize，防地图/图表渲染成 0×0
    setTimeout(() => this.resizeCharts(), 300);

    this.$nextTick(() => {
      // this.join();
      this.getData();
      this.initWarnToday();
      this.code = localStorage.getItem("code") || "";
      if (
        this.code == "429004" ||
        this.code == "429005" ||
        this.code == "429006" ||
        this.code == "429021"
      ) {
        this.parentCode = this.code;
      } else {
        this.parentCode = this.code.slice(0, 4) + "00";
      }
      this.codeText = areaIdMap[Number(this.parentCode)] || null;
      if (this.codeText) {
        this.currentLevel = "city";
        this.loadCityMap(this.codeText);
      } else {
        this.initMap();
      }
    });
  },
  beforeDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }
    if (this.useUnitSwiper) {
      this.useUnitSwiper.destroy(true, true);
      this.useUnitSwiper = null;
    }
    if (this.realWarnSwiper) {
      this.realWarnSwiper.destroy(true, true);
      this.realWarnSwiper = null;
    }
  },
  // watch: {
  //   realWarnList() {
  //     this.$nextTick(() => {
  //       this.swiperInitWarn(); // 等 DOM 更新完成再初始化 Swiper
  //     });
  //   },
  // },
  methods: {
    resizeCharts() {
      [
        "map",
        "warnToday",
        "warnTime",
        "warnTypeSeven",
        "warnTypeThirty",
        "malfunction",
      ].forEach((id) => {
        const element = document.getElementById(id);
        const chart = element && echarts.getInstanceByDom(element);
        if (chart && !chart.isDisposed()) {
          chart.resize();
        }
      });
    },
    percentage(value, total) {
      if (!Number(total)) {
        return "0.00";
      }
      return ((Number(value) || 0) / Number(total) * 100).toFixed(2);
    },
    showBack() {
      return this.currentLevel === "city";
    },
    // join() {
    //   const wsuri = this.url;
    //   let that = this;
    //   this.webSocket = new WebSocket(wsuri);
    //   this.webSocket.onopen = function (event) {
    //     console.log("连接成功");
    //     that.text_content = that.text_content + "已经打开连接!" + "\n";
    //   };
    //   this.webSocket.onmessage = function (event) {
    //     if (that.first) {
    //       that.send();
    //       that.first = false;
    //     }
    //     //接收消息
    //     console.log("接收消息", event);
    //     that.text_content = event.data + "\n";
    //     //接收消息处理

    //     if (event.data !== "连接成功" && event.data !== "heart") {
    //       console.log(JSON.parse(event.data), "event.dataevent.data");
    //       that.realWarnList = [JSON.parse(event.data)];
    //       setInterval(() => {
    //         that.send();
    //       }, 10000);
    //     }
    //   };
    //   this.webSocket.onerror = function (error) {
    //     console.error("WebSocket 出错", error);
    //     that.join();
    //   };
    //   this.webSocket.onclose = function (event) {
    //     that.text_content = that.text_content + "已经关闭连接!" + "\n";
    //   };
    // },
    // exit() {
    //   if (this.webSocket) {
    //     this.webSocket.close();
    //     this.webSocket = null;
    //   }
    // },
    // send() {
    //   if (this.webSocket) {
    //     this.webSocket.send(localStorage.getItem("token"));
    //   } else {
    //     // alert("未连接到服务器");
    //   }
    // },
    getData() {
      getDataCenter().then((res) => {
        const data = res && res.data && typeof res.data === "object" && !Array.isArray(res.data)
          ? res.data
          : {};
        this.formData = { ...this.formData, ...data };
        this.thirtyFault = Array.isArray(data.elevatorFaultStatVos) ? data.elevatorFaultStatVos : [];
        this.thirtyWarnType = Array.isArray(data.elevatorTypeVos) ? data.elevatorTypeVos : [];
        this.sevenWarn = Array.isArray(data.sevenDayElevatorListVos) ? data.sevenDayElevatorListVos : [];
        this.thirtyWarnTime = Array.isArray(data.thirtyDaysElevatorListVos) ? data.thirtyDaysElevatorListVos : [];
        this.thirtyWarnUnit = Array.isArray(data.unitElevatorListVos) ? data.unitElevatorListVos : [];
        this.realWarnList = Array.isArray(data.wbElevatorListVos) ? data.wbElevatorListVos : [];

        this.unitTotal = 0;
        this.thirtyWarnUnit.map((item) => {
          this.unitTotal += Number(item.count);
        });
        this.$nextTick(() => {
          this.swiperInitUseUnit();
          // this.initMalfunction();
          this.initWarnType();
          this.initWarnTypeSeven();
          this.initWarnTime();
          this.swiperInitWarn(); // 等 DOM 更新完成再初始化 Swiper
        });
      }).catch(() => {
        this.formData = {
          ...this.formData,
          totalElevators: 0,
          iotElevators: 0,
          onlineElevators: 0,
          offlineElevators: 0,
          usageUnit: 0,
          daysRelieveNo: 0,
          serviceNo: 0,
          dayNotNo: 0,
        };
        this.thirtyFault = [];
        this.thirtyWarnType = [];
        this.sevenWarn = [];
        this.thirtyWarnTime = [];
        this.thirtyWarnUnit = [];
        this.realWarnList = [];
        this.unitTotal = 0;
      });
      getBoardData().then((res) => {
        const data = res && res.data && typeof res.data === "object" && !Array.isArray(res.data)
          ? res.data
          : {};
        this.boardForm = { ...this.boardForm, ...data };
        this.$nextTick(() => {
          this.initMalfunction();
        });
      }).catch(() => {
        this.boardForm = {
          threeYearsNumber: 0,
          twoYearsNumber: 0,
          sixYearsNumber: 0,
          nineYearsNumber: 0,
          twelveYearsNumber: 0,
          fifteenYearsNumber: 0,
        };
      });
    },
    initMap(mapName = "hubei", geoJson = hubeiGeoJson, mapTitle = "湖北省") {
      const mapElement = document.getElementById("map");
      const myChart = echarts.getInstanceByDom(mapElement) || echarts.init(mapElement);
      this.myChart = myChart;
      echarts.registerMap(mapName, geoJson);

      const areaId = this.currentLevel === "province" ? "42" : areaNameMap[mapTitle] || mapTitle;
      getMapData({ areaId }).then((res) => {
        const mapList = res && Array.isArray(res.data) ? res.data : [];
        const mapData = mapDataToEcharts(mapList, geoJson);
        const pointData = mapDataToPoints(mapList, geoJson);
        const normalizeMapValue = (rawValue) => {
          const value = Array.isArray(rawValue) ? rawValue[2] : rawValue;
          const numericValue = Number(value);
          return Number.isFinite(numericValue) ? numericValue : 0;
        };
        const formatMapTooltip = (params) => {
          const value = normalizeMapValue(params.value);
          return `${params.name}<br/>电梯数量：${value} 台`;
        };
        const option = {
          title: {
            text: mapTitle,
            left: "center",
            textStyle: {
              color: "#fff",
              fontSize: 18,
              fontWeight: "bold",
            },
          },
          tooltip: {
            trigger: "item",
            formatter: formatMapTooltip,
          },
          geo: {
            map: mapName,
            // 允许在地图被面板遮挡时拖动查看，并限制缩放范围，避免地图被拖到视口外
            roam: true,
            scaleLimit: { min: 0.85, max: 1.8 },
            zoom: 1.15,
            label: {
              show: true,
              color: "#18384d",
              fontSize: 12,
              textBorderColor: "rgba(255, 255, 255, 0.35)",
              textBorderWidth: 1,
            },
            itemStyle: {
              areaColor: "#8FB8D6",
              borderColor: "#404a59",
            },
            emphasis: {
              itemStyle: { areaColor: "#f0a31a" },
            },
          },
          series: [
            {
              name: mapTitle,
              type: "map",
              map: mapName,
              geoIndex: 0,
              roam: false,
              label: {
                show: true,
                color: "#18384d",
                fontSize: 12,
                textBorderColor: "rgba(255, 255, 255, 0.35)",
                textBorderWidth: 1,
              },
              itemStyle: {
                areaColor: "#8FB8D6",
                borderColor: "#404a59",
              },
              emphasis: {
                label: { show: true, color: "#fff", fontWeight: "bold" },
                itemStyle: { areaColor: "#f0a31a" },
              },
              data: mapData,
            },
            {
              name: "电梯数量",
              type: "scatter",
              coordinateSystem: "geo",
              geoIndex: 0,
              z: 3,
              data: pointData,
              symbolSize: 14,
              itemStyle: {
                color: "#FFB000",
                shadowBlur: 12,
                shadowColor: "rgba(255, 176, 0, 0.9)",
                borderColor: "#FFF3A3",
                borderWidth: 1,
              },
              label: {
                show: false,
              },
              emphasis: {
                scale: 1.2,
                label: { show: false },
              },
              tooltip: {
                formatter: formatMapTooltip,
              },
            },
          ],
        };

        myChart.setOption(option, true);
        myChart.off("click");
        myChart.on("click", (params) => {
          if (this.currentLevel === "province" && params.seriesType === "map") {
            this.loadCityMap(params.name);
          }
        });
      }).catch(() => {
        myChart.setOption({
          title: {
            text: mapTitle,
            left: "center",
            textStyle: { color: "#fff", fontSize: 18, fontWeight: "bold" },
          },
          geo: {
            map: mapName,
            roam: true,
            scaleLimit: { min: 0.85, max: 1.8 },
            zoom: 1.15,
            label: {
              show: true,
              color: "#18384d",
              fontSize: 12,
              textBorderColor: "rgba(255, 255, 255, 0.35)",
              textBorderWidth: 1,
            },
            itemStyle: { areaColor: "#8FB8D6", borderColor: "#404a59" },
          },
          series: [{
            name: mapTitle,
            type: "map",
            map: mapName,
            geoIndex: 0,
            roam: false,
            label: {
              show: true,
              color: "#18384d",
              fontSize: 12,
              textBorderColor: "rgba(255, 255, 255, 0.35)",
              textBorderWidth: 1,
            },
            itemStyle: { areaColor: "#8FB8D6", borderColor: "#404a59" },
            data: [],
          }],
        }, true);
      });
    },
    loadCityMap(cityName) {
      // 市名转拼音映射（示例，建议完善）
      const cityMap = {
        十堰市: { mapName: "shiyan", geoJson: shiyan },
        神农架林区: { mapName: "shennongjia", geoJson: shennongjia },
        恩施土家族苗族自治州: { mapName: "enshi", geoJson: enshi },
        襄阳市: { mapName: "xiangyang", geoJson: xiangyang },
        宜昌市: { mapName: "yichang", geoJson: yichang },
        随州市: { mapName: "suizhou", geoJson: suizhou },
        荆门市: { mapName: "jingmen", geoJson: jingmen },
        荆州市: { mapName: "jingzhou", geoJson: jingzhou },
        孝感市: { mapName: "xiaogan", geoJson: xiaogan },
        天门市: { mapName: "tianmen", geoJson: tianmen },
        潜江市: { mapName: "qianjiang", geoJson: qianjiang },
        仙桃市: { mapName: "xiantao", geoJson: xiantao },
        武汉市: { mapName: "wuhan", geoJson: wuhan },
        黄冈市: { mapName: "huanggang", geoJson: huanggang },
        鄂州市: { mapName: "ezhou", geoJson: ezhou },
        黄石市: { mapName: "huangshi", geoJson: huangshi },
        咸宁市: { mapName: "xianning", geoJson: xianning },
        // 其他市对应json要补充
      };
      const city = cityMap[cityName];
      if (!city) {
        alert("未找到该市的地图数据！");
        return;
      }
      this.currentLevel = "city";
      this.currentMapName = city.mapName;
      if (this.myChart) {
        this.myChart.dispose(); // 销毁原图实例
      }
      this.initMap(city.mapName, city.geoJson, cityName); // 传入市区地图参数
    },
    backToProvince() {
      if (this.currentLevel === "city") {
        this.currentLevel = "province";
        this.currentMapName = "hubei";
        this.myChart.dispose();
        this.initMap("hubei", hubeiGeoJson, "湖北省");
      }
    },
    lookMask() {
      this.$refs.mask.open();
    },
    swiperInitUseUnit() {
      if (this.useUnitSwiper) {
        this.useUnitSwiper.destroy(true, true);
        this.useUnitSwiper = null;
      }

      const slideCount = this.thirtyWarnUnit.length;
      if (slideCount <= 4) {
        return;
      }

      const slidesPerView = 4;
      this.useUnitSwiper = new Swiper(".use_box", {
        slidesPerView,
        // 数据不足一页时关闭 loop，避免 Swiper 克隆数据导致排名重复显示。
        loop: slideCount > slidesPerView,
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
    swiperInitWarn() {
      if (this.realWarnSwiper) {
        this.realWarnSwiper.destroy(true, true);
        this.realWarnSwiper = null;
      }

      const slideCount = this.realWarnList.length;
      if (slideCount <= 1) {
        return;
      }

      const slidesPerView = 2;
      this.realWarnSwiper = new Swiper(".real_box", {
        slidesPerView,
        loop: slideCount > slidesPerView,
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },

    initWarnToday() {
      const data = [
        { name: "重复开关门", value: 365 },
        { name: "非平层停梯", value: 365 },
        { name: "非平层开门", value: 365 },
        { name: "蹲底", value: 365 },
        { name: "困人（AI）", value: 365 },
        { name: "开门故障", value: 365 },
      ];
      const colors = ["#3385FF", "#00CCFF", "#00FFFF", "#FF9933", "#FF3333", "#FFD700"];
      const charts = echarts.init(document.getElementById("warnToday"));
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}：{c} ({d}%)",
        },
        series: [
          {
            name: "告警类型",
            type: "pie",
            radius: ["55%", "70%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: colors,
            data,
          },
        ],
      };
      charts.setOption(option);
    },
    initWarnTime() {
      const xData = this.thirtyWarnTime.map((item) => {
        return item.faultType;
      });
      const yData = this.thirtyWarnTime.map((item) => {
        return item.count;
      });
      const charts = echarts.init(document.getElementById("warnTime"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 50,
          left: 40,
          right: 10,
          bottom: 30,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              color: "#3A4F66",
            },
          },
        },
        yAxis: {
          name: "单位：次",
          type: "value",
          axisLabel: {
            color: "#fff",
          },
          splitLine: {
            lineStyle: {
              color: "#3A4F66",
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            name: "数量",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            data: yData,
            lineStyle: {
              color: "#FFB91D", //折线颜色
            },
            itemStyle: {
              color: "#FFB91D", //折点颜色
              borderColor: "#fff",
              borderWidth: 1,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(0,198,255,0.4)" },
                { offset: 1, color: "rgba(0,198,255,0)" },
              ]),
            },
          },
        ],
      };
      charts.setOption(option);
    },
    initWarnTypeSeven() {
      const data = this.sevenWarn.map((item) => {
        return {
          name: item.faultType,
          value: item.count,
        };
      });
      const xData = data.map((item) => item.name);
      const yData = data.map((item) => item.value);
      const charts = echarts.init(document.getElementById("warnTypeSeven"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: 50,
          left: 10,
          right: 20,
          bottom: 20,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#fff",
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "#3A4F66",
            },
          },
        },
        yAxis: {
          name: "单位：%",
          type: "value",
          axisLabel: {
            color: "#fff",
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              color: "#3A4F66",
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
            padding: [0, 0, 0, 0],
          },
        },
        series: [
          {
            // name: "%",
            type: "bar",
            barWidth: 20,
            data: yData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00FFFF" },
                { offset: 1, color: "#0E697D" },
              ]),
            },
          },
        ],
      };
      charts.setOption(option);
    },
    initWarnType() {
      const data = this.thirtyWarnType.map((item) => {
        return {
          name: item.faultType,
          value: item.count,
        };
      });
      const xData = data.map((item) => item.name);
      const yData = data.map((item) => item.value);
      const charts = echarts.init(document.getElementById("warnTypeThirty"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: 50,
          left: 40,
          right: 20,
          bottom: 20,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#fff",
            fontSize: 8,
            align: "center", // 文字水平居中
            rotate: 14, // 文字旋转角度
          },
          axisLine: {
            lineStyle: {
              color: "#3A4F66",
            },
          },
        },
        yAxis: {
          name: "单位：次",
          type: "value",
          axisLabel: {
            color: "#fff",
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              color: "#3A4F66",
              type: "dashed",
            },
          },
          nameTextStyle: {
            color: "#fff",
            padding: [0, 0, 0, 0],
          },
        },
        series: [
          {
            name: "次数",
            type: "bar",
            barWidth: 20,
            data: yData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#3399FF" },
                { offset: 1, color: "#003366" },
              ]),
            },
          },
        ],
      };
      charts.setOption(option);
    },
    initMalfunction() {
      const data = [
        { name: "3年以下", value: this.boardForm.threeYearsNumber },
        { name: "3-6年", value: this.boardForm.twoYearsNumber },
        { name: "6-9年", value: this.boardForm.sixYearsNumber },
        { name: "9-12年", value: this.boardForm.nineYearsNumber },
        { name: "12-15年", value: this.boardForm.twelveYearsNumber },
        { name: "15年以上", value: this.boardForm.fifteenYearsNumber },
      ];
      const total = data.reduce((sum, item) => sum + item.value, 0) || 1;
      const colors = ["#3385FF", "#00CCFF", "#00FFFF", "#FF9933", "#FF3333", "#FFD700"];
      const charts = echarts.init(document.getElementById("malfunction"));
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}：{c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: 20,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          formatter: (name) => {
            const item = data.find((d) => d.name === name);
            const percent = ((item.value / total) * 100).toFixed(2);
            return `${name}  ${item.value} (${percent}%)`;
          },
        },
        series: [
          {
            name: "告警类型",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: colors,
            data,
          },
        ],
      };
      charts.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/viewport.scss";

.page_main {
  margin-top: vh(10);
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  column-gap: vw(20);
  .left {
    .general_box {
      width: 100%;
      .general_content {
        background: url("@/assets/image/g1.png") no-repeat center;
        background-size: 100% 100%;
        height: vh(220);
        padding: vh(15) vw(20);
        display: flex;
        align-items: center;
        .item_box {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          .item_list {
            height: vh(50);
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .icon {
              height: 100%;
              width: vw(64);
            }
            .list_desc {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              margin-left: vw(10);
              .label {
                font-weight: 400;
                font-size: vw(14);
                color: #b8c6d3;
              }
              .num {
                font-family: D-DIN;
                font-weight: 700;
                font-size: vw(18);
                color: #fff;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: vw(120);
                span {
                  font-size: vw(12);
                }
              }
            }
          }
        }
        .line {
          height: 100%;
          width: 1px;
          background: #00ffff;
          margin: auto vw(20);
        }
      }
    }
    .thirtydays_box {
      margin-top: vh(7);
      width: 100%;
      flex: 1;
      .thirtydays_content {
        height: calc(100% - vh(60));
        width: 100%;
        min-height: 0;
        overflow: hidden;
        position: relative;
        background: url("@/assets/image/g1.png") no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
  .center {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .map_box {
      width: 100%;
      flex: 1;
      position: relative;
      .back {
        position: absolute;
        margin: auto;
        cursor: pointer;
        left: 0;
        top: 0;
        background: url("@/assets/image/back.png") no-repeat center;
        background-size: 100% 100%;
        width: vw(124);
        height: vh(36);
        z-index: 999;
      }
      .map_content {
        width: 100%;
        height: 100%;
        cursor: grab;
        &:active {
          cursor: grabbing;
        }
      }
    }
    .center_bottom {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .charts_bottom_box {
        width: calc(50% - vw(10));
      }
    }
  }
  .right {
    .today_warn_box {
      width: 100%;
      .today_warn_content {
        background: url("@/assets/image/g1.png") no-repeat center;
        background-size: 100% 100%;
        height: vh(280);
        padding: vh(15) vw(20);
        display: flex;
        align-items: center;
        .today_charts {
          width: 50%;
          height: 100%;
        }
        .today_legend {
          width: 50%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-evenly;
          .legend_list {
            height: vh(48);
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
            .icon {
              width: vw(66);
              height: vh(48);
            }
            .line {
              height: vh(40);
              width: 1px;
              margin: auto vw(20);
            }
            .value_box {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-between;
              .status {
                display: flex;
                align-items: center;
                font-weight: 400;
                font-size: vw(14);
                color: #00cb61;
                .arrow {
                  margin-right: vw(10);
                  width: vw(14);
                  height: vh(12);
                }
                &.warn {
                  color: #e2b400;
                }
                &.danger {
                  color: #d01c00;
                }
              }
              .value {
                width: vw(25);
                height: vh(26);
                font-family: D-DIN;
                font-weight: 700;
                font-size: vw(24);
                color: #fff;
                line-height: vh(26);
              }
            }
          }
        }
      }
    }
      .real_time {
      width: 100%;
      flex: 1;
      overflow: hidden;
      margin-top: vh(7);
      margin-bottom: vh(5);

        .real_content {
        height: calc(100% - vh(42));
        width: 100%;
        background: url("@/assets/image/g1.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;

          .real_box {
          height: calc(100% - vh(30));
          width: calc(100% - vw(40));
            overflow: hidden;

            &.empty_state {
              display: flex;
              align-items: center;
              justify-content: center;
            }

          .real_list {
            height: 50%;
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: center;
            .item_list {
              display: flex;
              width: calc(100% - vw(20));
              padding: 0 vw(10);
              background: rgba(8, 85, 150, 0.29);
              height: calc(100% - vh(10));
              flex-direction: column;
              .label_box {
                height: 55%;
                display: flex;
                align-items: center;
                border-bottom: 1px dashed #1e4f7b;
                .tag {
                  width: vw(70);
                  height: vh(24);
                  background: url("@/assets/image/warn_icon.png") no-repeat center;
                  background-size: 100% 100%;
                  text-align: center;
                  font-weight: 700;
                  font-size: vw(12);
                  color: #fff;
                  line-height: vh(24);
                }
                .tag2 {
                  margin-left: vw(10);
                  background: rgba(79, 158, 232, 0.1);
                  box-shadow: inset 0px 0px 20px 0px rgba(0, 149, 250, 0.5);
                  border-radius: 60px;
                  border: 1px solid #0095fa;
                  padding: vh(4) vw(13);
                  font-weight: 400;
                  font-size: vw(12);
                  color: #fff;
                }
                .time {
                  font-weight: 400;
                  font-size: vw(12);
                  color: #b8c6d3;
                  text-align: right;
                  flex: 1;
                }
                .text {
                  font-weight: 700;
                  font-size: vw(12);
                  color: #fff;
                  margin-right: vw(6);
                }
              }
              .warn_bottom {
                display: flex;
                align-items: center;
                flex: 1;
                width: 100%;
                justify-content: space-between;
              }
            }
          }
        }
      }
    }
    .use_box {
      overflow: hidden;
      position: relative;
      .unit_list {
        padding: 0 vw(30);
        height: vh(60);
        box-sizing: border-box;
        .sort_item {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          height: 100%;
          width: 100%;
          .sort_info {
            display: flex;
            align-items: center;
            .icon {
              width: vw(16);
              height: vw(16);
              margin-right: vw(6);
            }
            .sort {
              font-weight: 700;
              font-size: vw(12);
              color: #fff;
            }
            .value {
              flex: 1;
              text-align: right;
              font-weight: 700;
              font-size: vw(12);
              color: #00abfa;
              &.first {
                color: #ff9900;
              }
            }
          }
          .process_box {
            width: 100%;
            height: vh(4);
            background: rgba(255, 185, 29, 0.1);
            .process {
              height: 100%;
              background: linear-gradient(270deg, #00abfa 0%, #90e3ff 100%);
              position: relative;
              &.active {
                background: linear-gradient(270deg, #ff9900 0%, #fad789 100%);
              }
              .process_line {
                position: absolute;
                margin: auto;
                right: 0;
                top: 0;
                bottom: 0;
                width: vw(2);
                height: vh(8);
                background: #fff;
                border-radius: 1px;
              }
            }
          }
        }
      }
    }
  }
  .side_list {
    width: vw(455);
    flex: 0 0 vw(455);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .charts_bottom_box {
    width: 100%;
    .charts_container {
      height: vh(180);
      margin-top: vh(6);
      background: url("@/assets/image/bottom_bg.png") no-repeat center;
      background-size: 100% 100%;
      position: relative;
    }
  }
  .item_box {
    display: flex;
    flex-direction: column;
    width: 100%;
    .item_title_box {
      width: calc(100% - vw(40));
      height: vh(36);
      background: url("@/assets/image/box_title_bg.png") no-repeat center;
      background-size: 100% 100%;
      margin-bottom: vh(6);
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: vw(24);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: vw(40);
    }
  }
}
.empty_image {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  display: block;
  width: 45%;
  max-width: 320px;
  max-height: 65%;
  height: auto;
  object-fit: contain;
  margin: 0;
  transform: translate(-50%, -50%);
}
.nothing {
  display: block;
  width: 45%;
  max-width: 320px;
  max-height: 65%;
  height: auto;
  object-fit: contain;
  margin: 0 auto;
}
</style>
